// import {useState, useEffect, useRef} from "react";
// import SectionTitle from "../SectionTitles/SectionTitle";
import SectionTitleTwo from "../SectionTitles/SectionTitleTwo";
// import Tilt from 'react-parallax-tilt';
// import Parallax from 'parallax-js';
// import {Link} from "react-router-dom";

const HomeAbout = () => {
  // const [scale] = useState(1.04);
  // const sceneEl = useRef(null);

  // useEffect(() => {
  //     const parallaxInstance = new Parallax(sceneEl.current, {
  //     relativeInput: true,
  //     })

  //     parallaxInstance.enable();

  //     return () => parallaxInstance.disable();

  // }, [])
  return (
    <div className="section section-padding-t90 section-padding-bottom-100">
      <div className="container">
        {/* <SectionTitle title="Introduction" /> */}

        <div className="row">
          <div
            className="col-xl-6 col-lg-6 col-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-content-area">
              <SectionTitleTwo
                // subTitle="Every day brings new challenges"
                title="Overview of International Conference on Swarm Intelligence (ICSI)"
              />
              <div className="intro">
                <p>
                  The Fourteenth International Conference on Swarm Intelligence
                  (ICSI&apos;2023) serves as the most important forum for
                  researchers and practitioners to exchange latest advantages in
                  theories, technologies, and applications of swarm intelligence
                  and related areas.
                </p>
                <br></br>
                <p>
                  Swarm intelligence (SI) is an important concept in artificial
                  intelligence and computer science with emergent properties. SI
                  is one of the most effective methods to confront the modern
                  complex problems in real world. A lot of novel algorithms are
                  springing up. ICSI provides the best communication
                  opportunities for SI researchers and practitioners annually.
                </p>
                <br></br>
                <p>
                  Shenzhen, located on the southern coast of China, adjacent to
                  Hong Kong, is an international morden city in Guangdong
                  Province. Shenzhen is the earliest Special Economic Zone in
                  China. It has developed rapidly due to Reform and Opening-up.
                  It is currently the third largest city in mainland China in
                  terms of economic aggregate. Shenzhen is an important
                  high-tech R&amp;D and manufacturing base in southern China,
                  and is often referred to as the &quot;Silicon Valley of
                  China&quot;. High-tech industry, financial industry, modern
                  logistics industry and cultural and creative industry are the
                  four pillar industries of Shenzhen. At the same time, Shenzhen
                  has developed public cultural services, frequent cultural
                  performances, and a beautiful ecological environment. It is
                  the most suitable dynamic city for talents at home and abroad
                  to expand their business.
                </p>
              </div>

              {/* <Link className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" to={process.env.PUBLIC_URL + "/about"}>Learn More</Link> */}
            </div>
          </div>

          <div
            className="col-xl-6 col-lg-6 col-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-content-area">
              {/* <SectionTitleTwo 
                                // subTitle="Every day brings new challenges"
                                title="International Conference on Swarm Intelligence"
                            /> */}

              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <p>
                The ICSI&apos;2023 is the fourteenth annual event in this
                high-reputation ICSI series following the continuous twelfth
                previous events at Xi&apos;an (Online Webinar), Qingdao
                ,Belgrade (Online Webinar), Chiang Mai, Shanghai, Fukuoka, Bali,
                Beijing, Hefei, Harbin, Shenzhen, Chongqing and Beijing.
              </p>
              <br></br>
              <p>
                Papers presented at the ICSI&apos;2023 will be published by
                Springer-Nature in Lecture Notes in Computer Science (indexed by
                EI Compendex, ISTP, DBLP, SCOPUS, Web of Science ISI Thomson,
                etc.). The downloads of our meeting&apos;s proceedings reach the
                top 10% of all publications of Springer-Nature.
              </p>
              <br></br>
              <p>
              Some high-quality papers will be selected for SCI-indexed Transaction and Journal (including IEEE Trans, IASEI Trans. Swarm Intelligence, IJSIR, Swarm and Evolutionary Optimization, Frontier in Neuroscience, Springer-Nature (SN) Computer Science, etc.) and Journal Special Issues:
                {/* <li>
                  International Journal of Intelligent System (IJIS, IF=10.78)
                </li> */}
                <li>Frontier in Neuroscience (IF=4.501)</li>
                <li>Electronics (IF=2.412)</li>
                <li>Entropy (IF=2.524)</li>
                {/* <li>Algorithms (IF=2.267)</li> */}
                <li>SN Computer science</li>
                {/* <li>IASEI Transactions on Swarm Intelligence</li> */}
                <li>……</li>
              </p>

              {/* <Link className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" to={process.env.PUBLIC_URL + "/about"}>Learn More</Link> */}
            </div>
          </div>
        </div>
      </div>
      <div className="space-50"></div>
    </div>
  );
};

export default HomeAbout;
